import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationModel } from '../models/location.model';
import { OnlineBookingUrlDto } from '../dtos/online-booking-url.dto';
import { FormFactory } from '../../../shared/mappers/form.factory';
import { CustomValidators } from '../../../shared/validators/custom-validators';

export class LocationFormFactory {
  static createLocationForm(fb: FormBuilder, locationModel: LocationModel): FormGroup {
    return fb.group({
      locationId: [locationModel.locationId, [Validators.required, CustomValidators.integer]],
      name: [locationModel.name, [Validators.required]],
      externalId: [locationModel.externalId, [Validators.required, CustomValidators.integer]],

      street: [locationModel.street, [Validators.required]],
      zipCode: [locationModel.zipCode, [Validators.required]],
      city: [locationModel.city, [Validators.required]],
      country: [locationModel.country, [Validators.required, CustomValidators.countryCode]],
      phone: [locationModel.phone, [CustomValidators.isoE164]],
      mobile: [locationModel.mobile, [CustomValidators.isoE164]],
      emailAddress: [locationModel.emailAddress, [Validators.required, Validators.email]],
      homePageUrl: [locationModel.homePageUrl, [CustomValidators.url]],

      senderEmail: [locationModel.senderEmail],
      senderName: [locationModel.senderName],

      maxAdvanceBookingDays: [locationModel.maxAdvanceBookingDays, [Validators.required, CustomValidators.integer]],
      minFutureBookingHours: [locationModel.minFutureBookingHours, [Validators.required, CustomValidators.integer]],
      minAdvanceCancellationHours: [locationModel.minAdvanceCancellationHours, [Validators.required, CustomValidators.integer]],
      minGroupAppointmentAdvanceCancellationHours: [locationModel.minGroupAppointmentAdvanceCancellationHours, [Validators.required, CustomValidators.integer]],
      maxGroupAppointmentsPerWeek: [locationModel.maxGroupAppointmentsPerWeek, [CustomValidators.integer]],
      maxAppointmentsPerWeek: [locationModel.maxAppointmentsPerWeek, [CustomValidators.integer]],
      maxAppointmentsTotal: [locationModel.maxAppointmentsTotal, [CustomValidators.integer]],
      maxAppointmentFrequency: [locationModel.maxAppointmentFrequency, [Validators.required, CustomValidators.integer]],
      startTimeIntervalMinutes: [locationModel.startTimeIntervalMinutes, [Validators.required, CustomValidators.integer, Validators.min(1)]],
      startIntervalRelativeToSlot: [locationModel.startIntervalRelativeToSlot, [CustomValidators.integer]],
      groupAppointmentWithSubscriptionOnly: [locationModel.groupAppointmentWithSubscriptionOnly],

      minAppAdvanceCancellationHours: [locationModel.minAppAdvanceCancellationHours, [Validators.required, CustomValidators.integer]],
      appCanCancelAppointment: [locationModel.appCanCancelAppointment],
      hideAnyTherapist: [locationModel.hideAnyTherapist],
      imageUrl: [locationModel.imageUrl],
      hideBookingWarning: [locationModel.hideBookingWarning],
      primaryColor: [locationModel.primaryColor ?? '#000000'],
      secondaryColor: [locationModel.secondaryColor ?? '#000000'],
      tertiaryColor: [locationModel.tertiaryColor ?? '#000000'],
      bookingHint: FormFactory.createLocalizedTextsForm(fb, locationModel.bookingHint),
      warnOnTherapistChange: [locationModel.warnOnTherapistChange],

      applyColorsToEmails: [locationModel.applyColorsToEmails],
      useCompanyAsSender: [locationModel.useCompanyAsSender],
      confirmationText: FormFactory.createLocalizedTextsForm(fb, locationModel.confirmationText),
      preferredLanguage: [locationModel.preferredLanguage],
      suppressPatientEmails: [locationModel.suppressPatientEmails],
      emailNotificationSettings: [locationModel.emailNotificationSettings]
    });
  }

  static createAddLocationForm(fb: FormBuilder): FormGroup {
    return fb.group({
      name: ['', Validators.required],
      externalId: ['', Validators.required],

      street: ['', Validators.required],
      zipCode: ['', Validators.required],
      city: ['', Validators.required],
      phone: ['', CustomValidators.isoE164],
      mobile: ['', CustomValidators.isoE164],
      emailAddress: ['', [Validators.required, Validators.email]]
    });
  }

  static createOnlineBookingUrlForm(fb: FormBuilder, onlineBookingUrlDto: OnlineBookingUrlDto): FormGroup {
    return fb.group({
      name: FormFactory.createLocalizedTextsForm(fb, onlineBookingUrlDto.name),
      link: [onlineBookingUrlDto.link, [CustomValidators.url]],
    });
  }
}
